module.exports = __webpack_public_path__ + "img/serrs-excel.245d2613.png";